// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-col {\n  display: grid;\n}\n@media (min-width: 1440px) {\n.two-col {\n    grid-template-columns: repeat(2, 1fr);\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
